import { html, LitElement, css, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

import '../components/decklist';
import '../components/buildlist';
import '../components/popular';
import '../components/challenge';

import '../parts/card';

import style from './index.scss';
import { DATA_AREAS, DATA_CHANGELOG, DATA_CLASSES, DATA_STATUS, DATA_VERSIONS } from '../data/sources';
import { friendlyURL, setTitle, trackPage } from '../shared/utils';
import { VERSION_OVERRIDE } from '../shared/types';
export class IndexPage extends LitElement {

    static get properties() {
        return {
            popular: String,
            news: Object,
            discord: Object,
            challenge: Object
        }
    }

    constructor() {
        super();
        this.popular = '';
        this.news = {
            id: 0,
            title: 'Loading...',
            content: ''
        };
        this.discord = {
            id: 0,
            title: 'Loading...',
            content: ''
        };
        this.challenge = null;
    }

    connectedCallback() {
        super.connectedCallback();
        trackPage();
        setTitle();                
        this.fetchData();
    }

    async fetchData() {        
        let res = await fetch(`./api/popularpage`);
        if (res.status === 200) {
            let json = await res.json();
            this.popular = json.popular;
        }       
        let wcres = await fetch(`./api/weeklychallenge`);
        if (wcres.status === 200) {
            let json = await wcres.json();
            this.challenge = json.challenge;
            if(json.decks){
                this.challenge.decks = json.decks;
            }
        }    
        let newsres = await fetch(`./api/news`);        
        if (newsres.status === 200) {
            let json = await newsres.json();                        
            if(json.news){
                this.news.id = json.news.id;
                this.news.title = json.news.title;
                this.news.content = json.news.content.replace(/<br \/>/g,' ').replace(/<p>/g,' ').replace(/<\/p>/g,' ');                
            }
            if(json.discord){
                this.discord.id = json.discord.id;
                this.discord.title = json.discord.title;
                this.discord.content = json.discord.content.replace(/<br \/>/g,' ').replace(/<p>/g,' ').replace(/<\/p>/g,' ');                
            }
            this.update();
        }
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    render() {        

        let veri = 0;
        let ver = DATA_VERSIONS[veri];
        while(DATA_CHANGELOG[ver.replace(/\./g,'-')]?.length === 0){
            veri += 1;
            ver = DATA_VERSIONS[veri];
        }

        return html`
            ${this.tooltip}                 
            <h3>News & Updates</h3>
            <a href="./changelog/${ver.replace(/\./g,'-')}">
                <div class="news">
                    <h3 class="class-rogue">Changelog</h3>
                    <h2>Changelog patch ${ver}</h2>
                    <div>Automated changelog for patch ${ver}. Checkout the new updates in this version!</div>
                    <p>Read more</p>
                </div>
            </a>
            <a href="./news/${this.news.id}">
                <div class="news">
                    <h3 class="class-hunter">News</h3>
                    <h2>${this.news.title}</h2>
                    <div>${unsafeHTML(this.news.content)}</div>
                    <p>Read more</p>
                </div>
            </a>
            <a href="./discordnews/${this.discord.id}">
                <div class="news">
                    <h3 class="class-knight">Discord Update</h3>                    
                    <div style="height: 170px;max-height:165px;">${unsafeHTML(this.discord.content.replace('</h2><br/>','</h2>'))}</div>
                    <p>Read more</p>
                </div>
            </a>            
            ${this.challenge?html`                          
                <challenge-component id=${this.challenge.uid} highlight="true"></challenge-component>           
            `:''}
            ${this.popular ? html`
            <popular-component url=${this.popular}></popular-component>
            `: ''}
            <h3>Classes</h3>    
            ${DATA_CLASSES.map((cls) => {
            return html`                        
                        <div class="bubble big" style="width:130px;font-size:18px;">
                            <a href="./class/${cls.name}"><img loading="lazy" class="class-image" src='./images/classes/${cls.artwork}.webp' alt=${cls.name} /> <div class="world-name class-${cls.name.toLowerCase()}">${cls.name}</div></a>
                        </div>         
                    `;
            })
            }          
            <decklist-component url="recentdecks"></decklist-component>      
            <decklist-component url="class/Scion" title="Trial of the Sunforge Runs"></decklist-component>              
            <h3>Cantos</h3>    
            ${DATA_AREAS.filter(area => area.expansion === 1).map((area, i) => {
                return html`
                        <div class="bubble big">
                            <a href="./area/${friendlyURL(area.name)}"><img loading="lazy" class="world" src="./images/card_world_${i + 1}.webp" alt=${area.areaName} /> <div class="world-name">${area.areaName}</div></a>
                        </div>
                    `;
            })
            }                
            <h3>Tribes of Twilight</h3>    
            ${DATA_AREAS.filter(area => area.expansion === 2).map((area) => {
                return html`
                        <div class="bubble big">
                            <a href="./area/${friendlyURL(area.name)}"><img loading="lazy" class="world" src="./images/card_world_${+area.name.substr(0, 2)}.webp" alt=${area.areaName} /> <div class="world-name">${area.areaName.replace('<br>', ' ')}</div></a>
                        </div>
                    `;
            })
            }           
            <h3>Death of Divinity</h3>  
            ${DATA_AREAS.filter(area => area.expansion === 3).map((area) => {
                return html`
                        <div class="bubble big">
                            <a href="./area/${friendlyURL(area.name)}"><img loading="lazy" class="world" src="./images/card_world_${+area.name.substr(0, 2)}.webp" alt=${area.areaName} /> <div class="world-name">${area.areaName.replace('<br>', ' ')}</div></a>
                        </div>
                    `;
            })
            }
            <h3>Masks of Misery</h3>  
            ${DATA_AREAS.filter(area => area.expansion === 6).map((area) => {
                return html`
                        <div class="bubble big">
                            <a href="./area/${friendlyURL(area.name)}"><img loading="lazy" class="world" src="./images/card_world_${+area.name.substr(0, 2)}.webp" alt=${area.areaName} /> <div class="world-name">${area.areaName.replace('<br>', ' ')}</div></a>
                        </div>
                    `;
            })
            }
            <h3>Siege of Shadows</h3>  
            ${DATA_AREAS.filter(area => area.expansion === 8).map((area) => {
                return html`
                        <div class="bubble big">
                            <a href="./area/${friendlyURL(area.name)}"><img loading="lazy" class="world" src="./images/card_world_${+area.name.substr(0, 2)}.webp" alt=${area.areaName} /> <div class="world-name">${area.areaName.replace('<br>', ' ')}</div></a>
                        </div>
                    `;
            })
            }
            <h3>Infernal Invasion</h3>  
            ${DATA_AREAS.filter(area => area.expansion === 11).map((area) => {
                return html`
                        <div class="bubble big">
                            <a href="./area/${friendlyURL(area.name)}"><img loading="lazy" class="world" src="./images/card_world_${+area.name.substr(0, 2)}.webp" alt=${area.areaName} /> <div class="world-name">${area.areaName.replace('<br>', ' ')}</div></a>
                        </div>
                    `;
            })
            }
            <h3>Invasion Types</h3>  
            ${DATA_AREAS.filter(area => area.expansion === 99).map((area) => {
                return html`
                        <div class="bubble big">
                            <a href="./area/${friendlyURL(area.name)}"><div class="world-name">${area.areaName.replace('<br>', ' ')}</div></a>
                        </div>
                    `;
            })
            }
            <h3>Status Effects</h3>  
            ${DATA_STATUS.map((status) => {
                return html`
                        <div class="bubble big">
                            <a href="./status/${status.name}"><img loading="lazy" class="world" src="./images/status/${status.artwork}.webp" alt=${status.name} /> <div class="status-name">${status.name}</div></a>
                        </div>
                    `;
            })
            }
            <h3>Changelogs</h3>  
            ${Object.keys(DATA_CHANGELOG).map((ver,i) => {      
                if(DATA_CHANGELOG[ver].length === 0)
                    return '';          
                return html`
                        <div class="bubble big">
                            <a href="./changelog/${ver}"><div class="world-name">${(VERSION_OVERRIDE[ver] ? VERSION_OVERRIDE[ver] : ver).replace(/\-/g, '.')}</div></a>
                        </div>
                    `;
            })
            }
        `;
    }
}

customElements.define('index-page', IndexPage);